import AContainer from '../../library/ExtendedObjects/AContainer.js';
import gameData from '../../gameData.js';
import ABCyaPhaser from '@abcya/abcya_phaser';
import FontKeys from '../../FontKeys.js';

export default class Popup extends AContainer {
  constructor(scene) {
    super(scene);

    this.createShader();
    this.createPopup();
    this.tweenInPopup();
  }

  createShader() {
    let rect = new Phaser.Geom.Rectangle(0, 0, this.scene.mid.x * 2, this.scene.mid.y * 2);
    this.shader = this.scene.add.graphics({ fillStyle: { color: 0x113940 } });
    this.shader.fillRectShape(rect);
    this.shader.setDepth(10);

    this.shader.alpha = 0;
  }

  createPopup() {
    this.popup = this.scene.add.container(this.scene.mid.x, this.scene.mid.y);

    const popupBg = this.scene.addImage(0, 0, "PausePopup", this.scene.defaultAtlas, this.popup);
    this.exit = this.scene.addImage(-popupBg.width / 4 + 20, 0, "ExitBtn", this.scene.defaultAtlas, this.popup);
    this.resume = this.scene.addImage(popupBg.width / 4 - 20, 0, "ResumeBtn", this.scene.defaultAtlas, this.popup);

    const exitTxt = ABCyaPhaser.Text.addText(this.exit.x, this.exit.y + 85, 32, 0xe2d4bc, FontKeys._Tertre_Med, ABCyaPhaser.Localization.instance.getLocalizedString('exit'), this.popup).setResolution(1.5).setShadow(2, 2, '#222');

    const resumeTxt = ABCyaPhaser.Text.addText(this.resume.x, this.resume.y + 85, 32, 0xe2d4bc, FontKeys._Tertre_Med, ABCyaPhaser.Localization.instance.getLocalizedString('resume'), this.popup).setResolution(1.5).setShadow(2, 2, '#222');

    const pausedTxt = ABCyaPhaser.Text.addText(0, -popupBg.height / 2 - 30, 50, 0xe2d4bc, FontKeys._Tertre_Med, ABCyaPhaser.Localization.instance.getLocalizedString('paused'), this.popup).setResolution(1.5).setShadow(2, 2, '#222');

    let txt;
    if (gameData.round === 1) {
      txt = ABCyaPhaser.Localization.instance.getLocalizedString('instructions.step_1');
    }
    else if (gameData.round === 2) {
      txt = ABCyaPhaser.Localization.instance.getLocalizedString('instructions.step_2');
    }
    else if (gameData.round === 3) {
      txt = ABCyaPhaser.Localization.instance.getLocalizedString('instructions.step_3');
    }
    const instructions = ABCyaPhaser.Text.addText(0, -95, 20, 0xe2d4bc, FontKeys._Tertre_Med, txt, this.popup).setResolution(1.5).setWordWrapWidth(popupBg.width - 70).setShadow(1, 1, '#222');

    this.popup.setDepth(11);
    this.popup.setScale(0, 0);

    this.resume.on("pointerup", () => { this.tweenOutPopup("resume"); });
    this.exit.on("pointerup", () => { this.tweenOutPopup("exit"); });
  }

  tweenInPopup() {
    this.scene.playSound("text_tween");

    this.scene.addTween(this.shader, 500, { alpha: .66 }, Phaser.Math.Easing.None);
    this.scene.addTween(this.popup, 1000, { scaleX: 1, scaleY: 1 }, Phaser.Math.Easing.Back.Out,
      () => { this.enableButtons(); });
  }

  tweenOutPopup(type) {
    this.scene.playSound("text_tween");
    this.scene.playSound("click");

    this.disableButtons();

    this.scene.addTween(this.shader, 500, { alpha: 0 }, Phaser.Math.Easing.None);
    this.scene.addTween(this.popup, 500, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.Back.In,
      () => {
        if (type === "resume") {
          this.scene.resumeGame();
        } else {
          this.scene.cleanUp('Intro');
        }
      });
  }

  enableButtons() {
    this.exit.setInteractive();
    this.resume.setInteractive();
  }

  disableButtons() {
    this.exit.disableInteractive();
    this.resume.disableInteractive();
  }

  cleanUp() {
    this.disableButtons();

    this.popup.destroy();
    this.shader.destroy();
  }
}